import { Button } from '@/components/form/Button';
import { ButtonVariant } from '@/components/form/buttonHelper';
import { Loading } from '@/components/loading/Loading';
import { Modal } from '@/components/modal/Modal';
import { ModalProps } from '@/components/modal/useModal';
import { Card } from '@/components/sections/Card';
import { useDisablePartner, usePartner } from '@/services/api/hooks/partners';

import { FunctionComponent, Suspense } from 'react';
import { toast } from 'sonner';

const DisableMspModal: FunctionComponent<ModalProps<{ mspId: string }>> = props => {
  const DisableMsp = () => {
    const mspId = props.props?.mspId;
    if (!mspId) throw new Error('Missing partner id');

    const [partner] = usePartner(mspId);

    const disablePartner = useDisablePartner();
    const onDisable = async () => {
      await disablePartner.mutateAsync({
        id: mspId
      });
      props.close();
      toast.success(`${partner.name} disabled`);
    };

    return (
      <Card className="w-full p-8">
        <Modal.Controls {...props}>
          <h1 className="text-2xl font-semibold">Disable MSP</h1>
        </Modal.Controls>

        <div className="space-y-2">
          <p className="text-lg">
            Are you sure you want to disable: <span className="font-semibold">{partner.name}?</span>
          </p>

          <div className="flex gap-2 justify-end">
            <Button className="flex-1" onClick={props.close}>
              Cancel
            </Button>
            <Button
              type="button"
              className="flex-1"
              variant={ButtonVariant.Destructive}
              loading={disablePartner.isLoading}
              onClick={onDisable}
            >
              Disable
            </Button>
          </div>
        </div>
      </Card>
    );
  };

  return (
    <Modal className="md:max-w-xl" {...props}>
      <Suspense fallback={<Loading />}>
        <DisableMsp />
      </Suspense>
    </Modal>
  );
};

export default DisableMspModal;
